import styled from "styled-components";

export default styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius:60%;
  width: 100px;
  height: 200px;
  background: none;
  color: #fff;
  margin: 0 15px;
  font-size: 4em;
`;